// HOSTING ENVIRONMENT
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as string;
export const APP_HOST_URL = process.env.REACT_APP_APP_HOST_URL as string;

// API
export const API_HOST = process.env.REACT_APP_API_HOST as string;
export const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH as string;
export const BASE_URL = API_HOST + "/" + API_BASE_PATH;
export const BASE_IMAGE = process.env.REACT_APP_API_IMAGE_PATH as string;
export const API_PUBLIC_AUTHORIZATION_TOKEN = process.env
  .REACT_APP_API_PUBLIC_AUTHORIZATION_TOKEN as string;

// CRYPTO
export const CRYPTO_CIPHER_KEY = process.env
  .REACT_APP_CRYPTO_CIPHER_KEY as string;

// APP ENVIRONMENT
export const APP_DEFAULT_LANGUAGE = process.env
  .REACT_APP_APP_DEFAULT_LANGUAGE as string;
export const PER_PAGE_ROW_LIST = process.env.REACT_APP_PER_PAGE_ROW_LIST?.split(
  ","
).map(Number) as number[];
export const PER_PAGE_ROWS = Number(process.env.REACT_APP_PER_PAGE_ROWS);
export const SESSION_ITA = Number(process.env.REACT_APP_SESSION_ITA);
export const SESSION_SIT = Number(process.env.REACT_APP_SESSION_SIT);

// IMAGE PATH
export const IMAGE_PATH = process.env.REACT_APP_IMAGE_URL as string;

export const ADMIN_CUSTOM_HEADER = process.env
  .REACT_APP_ADMIN_CUSTOM_HEADER as string;
